__turbopack_context__.v({
  "dragging": "UploadCalls-module__jaCd8q__dragging",
  "dropIcon": "UploadCalls-module__jaCd8q__dropIcon",
  "dropSubtitle": "UploadCalls-module__jaCd8q__dropSubtitle",
  "dropTitle": "UploadCalls-module__jaCd8q__dropTitle",
  "dropZone": "UploadCalls-module__jaCd8q__dropZone",
  "fileIcon": "UploadCalls-module__jaCd8q__fileIcon",
  "fileItem": "UploadCalls-module__jaCd8q__fileItem",
  "fileList": "UploadCalls-module__jaCd8q__fileList",
  "fileMeta": "UploadCalls-module__jaCd8q__fileMeta",
  "fileName": "UploadCalls-module__jaCd8q__fileName",
  "fileSize": "UploadCalls-module__jaCd8q__fileSize",
  "formatsText": "UploadCalls-module__jaCd8q__formatsText",
  "header": "UploadCalls-module__jaCd8q__header",
  "integrationBtn": "UploadCalls-module__jaCd8q__integrationBtn",
  "integrationsList": "UploadCalls-module__jaCd8q__integrationsList",
  "integrationsSection": "UploadCalls-module__jaCd8q__integrationsSection",
  "integrationsTitle": "UploadCalls-module__jaCd8q__integrationsTitle",
  "maxSizeInfo": "UploadCalls-module__jaCd8q__maxSizeInfo",
  "orSeparator": "UploadCalls-module__jaCd8q__orSeparator",
  "removeBtn": "UploadCalls-module__jaCd8q__removeBtn",
  "title": "UploadCalls-module__jaCd8q__title",
  "wrapper": "UploadCalls-module__jaCd8q__wrapper",
});
